import React, { Component } from "react";
import ReactApexChart from "react-apexcharts";
import PropTypes from "prop-types";
import { numberWithCommas, capitalizeFirstLetter } from "../../helpers/utils";

class DountChart extends Component {
  constructor(props) {
    super(props);

    this.state = {
      series: [],
      options: {},
    };
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.data !== this.props.data) {
      this.updateChart();
    }
  }

  updateChart = () => {
    const state = {
      series: [],
      options: {
        plotOptions: {
          pie: {
            expandOnClick: true,
          },
        },
        labels: [],
        colors: ["#34c38f", "#556ee6"],
        responsive: [
          {
            breakpoint: 600,
            options: {
              chart: {
                height: 240,
              },
              legend: {
                show: true,
              },
            },
          },
        ],
      },
    };

    const seriesKeys = [];
    const seriesData = {};

    const _categories = this.props.categories;
    const categories = [];

    this.props.data.map(i => {
      for (let [key, value] of Object.entries(i)) {
        if (seriesKeys.find(o => o === key) === undefined) {
          if (key !== _categories[0]) {
            seriesKeys.push(key);
            seriesData[key] = [];
          }
        }
      }
    });

    this.props.data.map((i, idx) => {
      for (let [key, value] of Object.entries(i)) {
        if (_categories.find(o => o === key)) {
          typeof value == "string"
            ? categories.push(
                value.length >= 14 ? value.substr(0, 14) + "..." : value
              )
            : categories.push(
                capitalizeFirstLetter(_categories[0]) + " " + value
              );
        }

        if (seriesKeys.find(o => o === key)) {
          seriesData[key].push(parseFloat(value));
        }
      }
    });

    let series = [];
    for (let [key, value] of Object.entries(seriesData)) {
      series = value;
    }

    let options = state;

    options.labels = categories;
    options.tooltip = {
      enabled: true,
      y: {
        formatter: value =>
          `${numberWithCommas(parseFloat(value))} ${
            (this.props.currency && this.props.currency) || ""
          }`,
        title: {
          formatter: tooltipName => capitalizeFirstLetter(tooltipName) + ":",
        },
      },
    };
    options.plotOptions = {
      pie: {
        expandOnClick: true,
        donut: {
          labels: {
            show: true,
            name: {
              fontFamily: "Helvetica, Arial, sans-serif",
              fontWeight: 400,
              offsetY: -5,
              formatter: name =>
                name.length >= 14 ? name.substr(0, 14) + "..." : name,
            },
            value: {
              formatter: value =>
                `${numberWithCommas(parseFloat(value))} ${
                  (this.props.currency && this.props.currency) || ""
                }`,
            },
            total: {
              show: true,
              showAlways: false,
              label: "Total",
              fontSize: "18px",
              fontFamily: "Helvetica, Arial, sans-serif",
              fontWeight: 600,
              formatter: this.props.currency
                ? w => {
                    let z = w.globals.seriesTotals.reduce((a, b) => {
                      return (a = a + b);
                    });
                    return numberWithCommas(parseFloat(z)) + "" + "$";
                  }
                : w => {
                    return w.globals.seriesTotals.reduce((a, b) => {
                      let z = a + b;
                      return z;
                    }, 0);
                  },
            },
          },
        },
      },
    };
    this.setState({
      series,
      options,
    });
  };

  render() {
    return (
      <React.Fragment>
        <ReactApexChart
          options={this.state.options}
          series={this.state.series}
          type={this.props.typeChart}
          height="350"
          className="apex-charts"
        />
      </React.Fragment>
    );
  }
}

DountChart.propTypes = {
  data: PropTypes.any,
  yaxisName: PropTypes.string,
  categories: PropTypes.array,
  typeChart: PropTypes.string,
  currency: PropTypes.string,
};

export default DountChart;
